import { Container, Paper, TextField, Stack, Button, Typography} from "@mui/material";
import { doc, updateDoc} from "firebase/firestore";
import ReactQuill from "react-quill";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import firebaseConfig from "../firebase";
import { getFirestore } from 'firebase/firestore';
function RichTextUpdate(props) {
    const db = getFirestore(firebaseConfig)
    const navigate = useNavigate()
    const {id} : {id: string} = useParams();
    const {update} = useSelector(state=>({...state }))
    const [contentText, setContentText] = useState(update.contentText);
    const [contentType, setContentType] = useState(update.contentType);
    
    


    
 



    const update_text = async () => {
        const contentRef = doc(db, "Content", id);
        await updateDoc(contentRef, {
            contentText: contentText,
            contentType: contentType,
            contentIcon: "help-circle-outline",
        });
        alert("บันทึกเรียบร้อย")
        navigate('/content');
    }

    return (
<Container class={Paper}>
            <Stack spacing={3}>
            <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          แก้ไขคู่มือ 
        </Typography>
                <TextField   inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="หัวข้อ*" onChange={(event) => {
                    setContentType(event.target.value)
                }}
                    value={contentType} />
                <ReactQuill
                    value={contentText}
                    onChange={setContentText}
                    theme={'snow'}
                    modules={{
                        toolbar: [
                            [{ 'header': [1, 2, false] }, { 'font': [] }],
                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' },
                            { 'indent': '-1' }, { 'indent': '+1' }],
                            ['link', 'image', 'video'],
                            ['clean']
                        ]
                    }} />
                    <Stack direction="row" justifyContent="flex-end" spacing={3}>
                    <Button  sx={{ fontFamily:'Prompt'}}   onClick={() => navigate('/content')} variant="text" color="error">ยกเลิก</Button>
                <Button onClick={update_text} sx={{ fontFamily:'Prompt'}} variant="outlined" color="success">บันทึก</Button>
                </Stack>
            </Stack>
        </Container>
    );
}

export default RichTextUpdate